import Offcanvas from "react-bootstrap/Offcanvas";
import CustomSearchbar from "./CustomSearchbar";
import { ListGroup, Image } from "react-bootstrap";
import { useState } from "react";

export default function OffCanvasExample({ show, handleClose, dataList = [], onSelect = () => {} }) {
  const [results, setResults] = useState([]);

  const handleSelect = (item) => {
    // call parent handler (e.g., viewProduct) and close
    try {
      onSelect(item);
    } catch (e) {}
    handleClose();
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="top" style={{ zIndex: 1051 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Search</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <CustomSearchbar
          searchFlags={["title", "brand", "description"]}
          dataListTemp={dataList}
          stateUpdator={setResults}
          placeholders={["title", "brand"]}
        />

        <div style={{ maxHeight: 320, overflowY: "auto" }}>
          {results && results.length > 0 ? (
            <ListGroup>
              {results.map((item) => (
                <ListGroup.Item key={item._id} action onClick={() => handleSelect(item)}>
                  <div className="d-flex align-items-center">
                    <Image
                      src={item.imageUrl || "/img/placeholder.png"}
                      rounded
                      style={{ width: 56, height: 56, objectFit: "cover", marginRight: 12 }}
                    />
                    <div>
                      <div style={{ fontWeight: 600 }}>{item.title}</div>
                      <div className="text-muted small">Rs {item.price}</div>
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <div className="text-muted">Type to search products...</div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
